module.exports = __webpack_public_path__ + "e3eb6816e604d1369a98499f72aa5c70.pdf";